<template>
  <transition name="app-toast">
    <div
      v-if="value"
      class="app-toast"
      :class="'app-toast--' + kind"
      :role="kind === 'error' ? 'alert' : 'status'"
    >
      <div class="app-toast__head">
        <app-icon v-if="icon" :name="icon" :size="16" class="app-toast__icon" />
        <span class="app-toast__text"><slot>{{ text }}</slot></span>
        <app-icon-button
          v-if="closable"
          class="app-toast__close"
          icon="x"
          label="Schließen"
          :size="24"
          :boxed="false"
          tooltip="none"
          @click="close"
        />
      </div>
      <v-progress-linear
        v-if="showProgress"
        class="app-toast__bar"
        :value="progress === null ? 0 : progress"
        :indeterminate="indeterminate"
        color="primary"
        height="6"
        rounded
      ></v-progress-linear>
      <div v-if="count" class="app-toast__count">{{ count }}</div>
    </div>
  </transition>
</template>

<script>
// Toast unten rechts (Kundenwunsch 13.10.2026: „beim laden der paypal rückerstattungen erscheint unten rechts ein guter
// kleiner toast. dieses design bitte auch übernehmen wenn z.b. verkäufe oder saldo quittungen gedruckt werden. aktuell
// erscheint dort ein schwarzer toast“): Karte wie der frühere Fortschritt der PayPal-Seite – fest unten rechts über der
// unteren Navigation (bottom: var(--shell-unten) + 16), 340 breit, erhöhte Fläche, Kante, Kartenradius, Schatten wie
// Menüs; Kopf mit Icon 16 und Text 13/20 500, darunter auf Wunsch ein Fortschrittsbalken (6 hoch, indeterminate oder
// progress 0–100) und eine Zahl 12/16 („12 / 40 (30 %)“). Ersetzt die schwarze v-snackbar. v-model (value); timeout in
// ms (Standard 5000 wie die v-snackbar, 0 = bleibt stehen) beginnt bei jedem Öffnen und bei neuem Text von vorn. kind:
// info (Standard), ok (Icon grün) oder error (Icon rot, role="alert"). closable: Knopf „Schließen“ (x).
export default {
  name: 'AppToast',
  props: {
    value: { type: Boolean, default: false },
    text: { type: String, default: '' },
    icon: { type: String, default: null },
    kind: { type: String, default: 'info' },
    timeout: { type: Number, default: 5000 },
    closable: { type: Boolean, default: false },
    // Fortschritt 0–100; null ohne Balken (außer indeterminate)
    progress: { type: Number, default: null },
    indeterminate: { type: Boolean, default: false },
    count: { type: String, default: '' }
  },
  computed: {
    showProgress() {
      return this.indeterminate || this.progress !== null;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.restartTimer();
      }
    },
    text() {
      this.restartTimer();
    },
    timeout() {
      this.restartTimer();
    }
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    restartTimer() {
      clearTimeout(this.timer);
      if (this.value && this.timeout > 0) {
        this.timer = setTimeout(this.close, this.timeout);
      }
    },
    close() {
      clearTimeout(this.timer);
      this.$emit('input', false);
    }
  }
};
</script>

<style scoped>
.app-toast {
  position: fixed;
  bottom: calc(var(--shell-unten) + 16px);
  right: 16px;
  width: 340px;
  max-width: calc(100vw - 32px);
  /* über Detailbereich und Dialogen wie die frühere v-snackbar */
  z-index: 1000;
  box-sizing: border-box;
  padding: 12px 16px;
  background: var(--surface-raised);
  border: 1px solid var(--line);
  border-radius: var(--r-card);
  /* leichter Schatten wie Menüs, damit der Toast sich von Tabelle und Fußleiste abhebt */
  box-shadow: var(--sh-menu);
}
.app-toast__head {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  line-height: 20px;
  font-weight: 500;
  color: var(--ink);
}
.app-toast__icon {
  flex: none;
  color: var(--ink-3);
}
.app-toast--ok .app-toast__icon {
  color: var(--green-dot);
}
.app-toast--error .app-toast__icon {
  color: var(--red);
}
.app-toast__text {
  flex: 1 1 auto;
  min-width: 0;
  overflow-wrap: anywhere;
}
/* Schließen randlos, ragt nicht über die Zeilenhöhe hinaus */
.app-toast__close {
  flex: none;
  margin: -2px -6px -2px 0;
}
.app-toast__bar {
  margin-top: 8px;
}
.app-toast__count {
  margin-top: 4px;
  font-size: 12px;
  line-height: 16px;
  color: var(--ink-3);
  font-variant-numeric: tabular-nums;
}
.app-toast-enter-active,
.app-toast-leave-active {
  transition: opacity .15s ease, transform .15s ease;
}
.app-toast-enter,
.app-toast-leave-to {
  opacity: 0;
  transform: translateY(8px);
}
@media (prefers-reduced-motion: reduce) {
  .app-toast-enter-active,
  .app-toast-leave-active {
    transition: none;
  }
}
</style>
